// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"S3-z"};